<template>
	<div class="relative z-0">
		<button
			v-if="showControls && !disablePrev"
			@click="handlePrev"
			:disabled="disablePrev"
			class="absolute top-1/2 z-10 -translate-y-1/2 left-0 bg-white w-12 h-12 hidden lg:flex flex-col items-center justify-center"
			aria-label="Previous Slide"
		>
			<svg-vue icon="chevron-down" class="stroke-black w-8 h-8 rotate-90"></svg-vue>
			<span class="sr-only">Previous</span>
		</button>
		<div ref="emblaRef" class="w-full overflow-hidden">
			<div class="backface-hidden flex gap-2 touch-pan-y h-[383px] lg:h-[526px]">
				<slot />
			</div>
		</div>
		<button
			v-if="showControls && !disableNext"
			@click="handleNext"
			:disabled="disableNext"
			class="absolute top-1/2 z-10 hidden lg:flex -translate-y-1/2 right-0 bg-white w-12 h-12 flex-col items-center justify-center"
			aria-label="Next Slide"
		>
			<svg-vue icon="chevron-down" class="stroke-black w-8 h-8 -rotate-90"></svg-vue>
			<span class="sr-only">Next</span>
		</button>
	</div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import emblaCarouselVue from 'embla-carousel-vue'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

const props = defineProps({
	showControls: {
		type: Boolean,
		default: false,
	},
})
const [emblaRef, emblaApi] = emblaCarouselVue({}, [WheelGesturesPlugin()])
const selectedScrollSnap = ref(0)
const disablePrev = ref(true)
const disableNext = ref(false)

onMounted(() => {
	if (emblaApi.value) {
		emblaApi.value.on('scroll', () => {
			selectedScrollSnap.value = emblaApi.value.selectedScrollSnap()
			disablePrev.value = !emblaApi.value.canScrollPrev()
			disableNext.value = !emblaApi.value.canScrollNext()
		})
	}
})

const handlePrev = () => emblaApi.value.scrollPrev()
const handleNext = () => emblaApi.value.scrollNext()
</script>
